module.exports = __webpack_public_path__ + "static/bio-link-b8eed8e3b3368cfa72fd8604a8fe9c3a.png";